// extracted by mini-css-extract-plugin
export default {"orders":"order-list_orders__gqCGJ","subtitle":"order-list_subtitle__m0X8F"};